// extracted by mini-css-extract-plugin
export default {"root":"ExaminationDone_root__XbsVV"};